//import dashboard from './dashboard'
// import appsAndPages from './apps-and-pages'
import temp from './temp'
// Array of sections
export default [...temp]
